import { cn } from '@neo/lib/utils'
import {
  ArrowUpRight,
  Files,
  Globe2,
  Inbox,
  LockKeyhole,
  MapPin,
  MessageSquare,
  TriangleAlert,
  Wallet,
} from 'lucide-react'

const stateIcons = {
  empty: Inbox,
  documents: Files,
  error: TriangleAlert,
  balance: Wallet,
  geography: Globe2,
  locked: LockKeyhole,
  upgrade: ArrowUpRight,
  messages: MessageSquare,
  address: MapPin,
}

interface StateIllustrationProps {
  variant: keyof typeof stateIcons
  className?: string
}

export const StateIllustration = ({ variant, className }: StateIllustrationProps) => {
  const Icon = stateIcons[variant]
  return (
    <svg
      viewBox="0 0 200 168"
      className={cn('h-40 w-48 shrink-0', className)}
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M28 24H172M28 48H172M28 72H172M28 96H172M28 120H172M52 16V128M76 16V128M100 16V128M124 16V128M148 16V128"
        className="stroke-st2"
        strokeWidth="0.6"
        strokeDasharray="1 5"
      />
      <rect x="57" y="29" width="94" height="88" rx="2" className="fill-bg2 stroke-st2" />
      <rect
        x="47"
        y="19"
        width="94"
        height="88"
        rx="2"
        className="fill-background stroke-secondary"
        strokeWidth="1.4"
      />
      <path d="M47 37H141" className="stroke-st2" />
      <path d="M59 28H75" className="stroke-brand-text" strokeWidth="2" strokeLinecap="round" />
      <path d="M60 52H98M60 63H85M60 87H93M60 96H81" className="stroke-st1" strokeWidth="1.5" />
      <rect
        x="108"
        y="69"
        width="46"
        height="46"
        rx="2"
        className="fill-background stroke-brand-text"
        strokeWidth="1.4"
      />
      <rect x="112" y="73" width="38" height="38" rx="1" className="fill-brand/10" />
      <Icon x="119" y="80" width="24" height="24" strokeWidth="1.5" className="text-brand-text" />
      <path d="M42 131H158" className="stroke-st2" />
    </svg>
  )
}

interface IllustrationProps {
  className?: string
}

export const EmptyDataIllustration = (props: IllustrationProps) => (
  <StateIllustration variant="empty" {...props} />
)
export const DocumentsIllustration = (props: IllustrationProps) => (
  <StateIllustration variant="documents" {...props} />
)
export const ErrorIllustration = (props: IllustrationProps) => (
  <StateIllustration variant="error" {...props} />
)
export const BalanceIllustration = (props: IllustrationProps) => (
  <StateIllustration variant="balance" {...props} />
)
export const GeographyIllustration = (props: IllustrationProps) => (
  <StateIllustration variant="geography" {...props} />
)
export const RegionLockedIllustration = (props: IllustrationProps) => (
  <StateIllustration variant="locked" {...props} />
)
export const UpgradeIllustration = (props: IllustrationProps) => (
  <StateIllustration variant="upgrade" {...props} />
)
export const MessagesIllustration = (props: IllustrationProps) => (
  <StateIllustration variant="messages" {...props} />
)
export const AddressIllustration = (props: IllustrationProps) => (
  <StateIllustration variant="address" {...props} />
)
